import { Dialog, DialogTitle, Transition, TransitionChild } from "@headlessui/react";
import React, { Fragment, useRef } from "react";
import { XMarkIcon } from '@heroicons/react/24/solid';
import InputMask from 'react-input-mask';

interface ConfirmDialogProps {
    text: string;
    title?: string;
    isOpen: boolean
    onClose: (confirmed: boolean, params?: any) => void,
    form?: formItem[],
    allowClose?: boolean
}

export interface formItem {
    label: string;
    name: string;
    type: 'input' | 'textarea' | 'timestamp';
    required?: boolean;
    value?: string | number;

}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({ text, title, isOpen, onClose, form, allowClose = true }) => {

    const formRef = useRef<HTMLFormElement>(null);

    const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
        if (event.target === event.currentTarget && allowClose) {
            onClose(false);
        }
    };

    const handleConfirm = async () => {
        if (formRef?.current) {
            const valid = formRef.current.reportValidity();
            if (valid) {
                const formData = new FormData(formRef.current);
                const data: Record<string, string> = {};
                formData.forEach((value, key) => {
                    data[key] = value.toString();
                });
                onClose(true, data);
            }

        } else onClose(true);

    };

    return <Transition show={isOpen} as={Fragment}>
        <Dialog as="div" className="fixed inset-0 z-30 overflow-y-auto " onClose={() => onClose(false)}>
            <div className="flex items-center justify-center min-h-screen bg-gray-800 bg-opacity-75 p-4" onClick={handleBackdropClick}>
                <TransitionChild
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                >
                    <div className="bg-white  dark:bg-gray-900 dark:text-gray-100 p-6 max-w-md rounded-lg shadow-lg w-full space-y-4" onClick={(e) => e.stopPropagation()}>
                        <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-gray-100 flex justify-between items-center">
                            <div>{title}</div>
                            <div className="text-right">

                                {allowClose &&
                                    <button onClick={() => onClose(false)} className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300">
                                        <XMarkIcon className="h-6 w-6" />
                                    </button>
                                }
                            </div>
                        </DialogTitle>
                        {text}
                        {form?.length && <form className="w-full" ref={formRef}>
                            {form?.map((field: formItem, key: number) => <div className="" key={key}>
                                {field.type === 'input' &&
                                    <input
                                        id={field.name}
                                        name={field.name}
                                        required={field.required || false}
                                        placeholder={field.label}
                                        value={field.value}
                                        className="w-full p-2 my-1 border border-gray-300 dark:bg-gray-900 rounded-md"
                                    />
                                }
                                {field.type === 'textarea' &&
                                    <textarea
                                        id={field.name}
                                        name={field.name}
                                        placeholder={field.label}
                                        required={field.required || false}
                                        value={field.value}
                                        className="w-full p-2 my-1 border border-gray-300 dark:bg-gray-900 rounded-md"
                                    />
                                }
                                {field.type === 'timestamp' &&
                                    <InputMask
                                        id={field.name}
                                        name={field.name}
                                        mask="99:99:99"
                                        required={field.required || false}
                                        value={field.value}
                                        className="w-full p-2 my-1 border border-gray-300 dark:bg-gray-900 rounded-md"
                                    />
                                }
                                    </div>)}
                            </form>
                        }

                            <div className="flex justify-end space-x-2">
                                <button className="border border-gray-500 hover:bg-gray-200 hover:dark:hover:bg-gray-700 rounded-md p-2 " onClick={() => onClose(false)} >Cancel</button>
                                <button
                                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                                    onClick={handleConfirm} >Confirm</button>
                            </div>
                        </div>
                </TransitionChild>
            </div>
        </Dialog>
    </Transition>
}

export default ConfirmDialog;